import cx from 'classnames'
import { useContext } from 'react'

import { getLinkPageUrl } from '@lib/routes'
import { StringsContext } from '@lib/strings-context'
import { UserContext } from '@lib/user/context'

import { ButtonVariant } from '@components/buttons/button'
import ButtonLink from '@components/buttons/button-link'
import { getIsUserB2bClient } from '@lib/user/helpers'

interface ProductActionsGuestProps {
  returnTo?: string
  className?: string
}

const ProductActionsGuest = ({
  returnTo,
  className,
}: ProductActionsGuestProps) => {
  const strings = useContext(StringsContext)
  const { user } = useContext(UserContext)

  const isUserB2bClient = getIsUserB2bClient(user)

  const signupPageUrl = getLinkPageUrl({
    pageType: 'signupPage',
  })
  const loginPageUrl = getLinkPageUrl({
    pageType: 'loginPage',
    parameters: {
      return_to: returnTo,
    },
  })

  return (
    <div className={cx('p-8 bg-[#eeeeee] rounded-md', className)}>
      <p className="font-medium text-base">
        {isUserB2bClient
          ? strings.productNotD2cClient
          : strings.productNotB2bClient}
      </p>

      <div className="mt-4">
        <ButtonLink href={signupPageUrl} variant={ButtonVariant.FILLED}>
          {strings.buttonSignup}
        </ButtonLink>
        <ButtonLink
          href={loginPageUrl}
          variant={ButtonVariant.OUTLINED}
          className="ml-4"
        >
          {strings.buttonLogin}
        </ButtonLink>
      </div>
    </div>
  )
}

export default ProductActionsGuest
